import {BooleanMethod, Method, MethodCategoriesEnum} from './internal';

export class CompareMethod extends BooleanMethod {
  comparatorEnum: {[key: string]: string};

  constructor(comparatorEnum: {[key: string]: string}) {
    super(MethodCategoriesEnum.COMPARE);
    this.comparatorEnum = comparatorEnum;
  }
}

export function isCompareMethod(method: Method | undefined): method is CompareMethod {
  return Boolean(method && method instanceof CompareMethod);
}
